import { render } from "./XIconSolidPackage.vue?vue&type=template&id=1da8f67e"
import script from "./XIconSolidPackage.vue?vue&type=script&lang=js"
export * from "./XIconSolidPackage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidPackage.vue"]])

export default __exports__